import { render, staticRenderFns } from "./IconAccount.vue?vue&type=template&id=75f6845b"
import script from "./IconAccount.vue?vue&type=script&lang=ts"
export * from "./IconAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports